/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { NgModule } from '@angular/core';
import { QueryViewComponent } from './query-view.component';
import { QueryViewDataComponent } from './data/query-view-data.component';
import { QueryViewDataContainerComponent } from './data/query-view-data-container/query-view-data-container.component';
import { QueryViewFilterCommodityComponent } from './data/query-view-filter-commodity/query-view-filter-commodity.component';
import { QueryViewFilterGeoComponent } from './data/query-view-filter-geo/query-view-filter-geo.component';
import { QueryViewFilterLocomotivesComponent } from './data/query-view-filter-locomotives/query-view-filter-locomotives.component';
import { QueryViewFilterTrainsComponent } from './data/query-view-filter-trains/query-view-filter-trains.component';
import { QueryViewFiltersComponent } from './data/query-view-filters/query-view-filters.component';
import { QueryViewHeaderComponent } from './data/query-view-header/query-view-header.component';
import { QueryViewLocoDataComponent } from './data/query-view-loco-data/query-view-loco-data.component';
import { QueryViewResolver } from './shared/query-view.resolver';
import { QueryViewRoutingModule } from './query-view-routing.module';
import { QueryViewService } from './shared/services/query-view.service';
import { QueryViewTrainDataComponent } from './data/query-view-train-data/query-view-train-data.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    QueryViewRoutingModule,
    CoreModule,
    DialogModule,
    SharedModule,
    TabViewModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    PanelModule,
    OverlayPanelModule,
    DropdownModule,
    CheckboxModule,
    RadioButtonModule
  ],
  providers: [QueryViewResolver, QueryViewService],
  declarations: [QueryViewComponent,
    QueryViewDataComponent,
    QueryViewHeaderComponent,
    QueryViewFilterLocomotivesComponent,
    QueryViewFilterTrainsComponent,
    QueryViewFilterGeoComponent,
    QueryViewFilterCommodityComponent,
    QueryViewFiltersComponent,
    QueryViewDataContainerComponent,
    QueryViewLocoDataComponent,
    QueryViewTrainDataComponent],

  exports: [QueryViewComponent]
})
export class QueryViewModule { }
